import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
    footerBG: props => ({
        width: "100%",
        height: `${props.height}px`,
        position: "fixed",
        top: props.top,
        left: "0",
        overflow: "hidden",
        zIndex: "-2",
    }),
})

export default function PartyFooterBg({ children, ...props }) {
    const classes = useStyles(props)
    return (
        <div className={classes.footerBG}>
            <img src={children} className="party-login-bg-img" alt="background" />
        </div>
    )
}